const DEFAULT_LOCAL_PUBLIC_BASE = "http://192.168.1.13/tccbackend";

const trimTrailingSlash = (value) => String(value || "").replace(/\/+$/, "");

const isLocalHost = (origin) =>
  /\/\/(localhost|127(?:\.\d{1,3}){3})(:\d+)?$/i.test(origin);

const inferPublicBase = () => {
  if (typeof window !== "undefined" && window.location?.origin) {
    const origin = trimTrailingSlash(window.location.origin);
    if (!isLocalHost(origin)) {
      return `${origin}/admin_dashboard/tccbackend`;
    }
  }

  return DEFAULT_LOCAL_PUBLIC_BASE;
};

export const MOBILE_BACKEND_PUBLIC_BASE = trimTrailingSlash(
  process.env.REACT_APP_MOBILE_BACKEND_PUBLIC_BASE_URL || inferPublicBase()
);

export const MOBILE_BACKEND_API_BASE = trimTrailingSlash(
  process.env.REACT_APP_MOBILE_BACKEND_API_BASE_URL || `${MOBILE_BACKEND_PUBLIC_BASE}/api`
);

const parseResponse = async (response) => {
  const contentType = String(response.headers.get("content-type") || "").toLowerCase();
  const text = await response.text();
  let payload = {};
  const looksLikeHtml = /^\s*<!doctype html/i.test(text) || /^\s*<html/i.test(text);

  try {
    payload = text.trim() ? JSON.parse(text) : {};
  } catch {
    payload = {
      message: looksLikeHtml
        ? "Unexpected HTML response from mobile backend."
        : text.trim(),
    };
  }

  if (!response.ok || payload?.success === false || (!contentType.includes("application/json") && looksLikeHtml)) {
    const error = new Error(payload?.message || `Request failed (${response.status})`);
    error.status = response.status;
    error.payload = payload;
    throw error;
  }

  return payload;
};

export const fetchNotificationUsers = async () => {
  const response = await fetch(`${MOBILE_BACKEND_API_BASE}/notification_users.php?with_token=1`);
  return parseResponse(response);
};

export const sendPushNotification = async ({
  title,
  body,
  userIds,
  imageFile,
  screen = "notifications",
  type = "custom_notification",
}) => {
  const formData = new FormData();
  formData.append("title", title);
  formData.append("body", body);
  formData.append("screen", screen);
  formData.append("type", type);
  formData.append("public_base_url", MOBILE_BACKEND_PUBLIC_BASE);
  formData.append("user_ids", JSON.stringify(userIds || []));

  if (imageFile) {
    formData.append("image", imageFile);
  }

  const response = await fetch(`${MOBILE_BACKEND_API_BASE}/send_notification.php`, {
    method: "POST",
    body: formData,
  });

  return parseResponse(response);
};
